module.exports = __webpack_public_path__ + "static/media/religare_icn_landing_card_1.b41c0398.png";